import { NavigationGuard, NavigationGuardNext, RouteLocationNormalized } from "vue-router"

let _isInit = false
const _globalGuardians: Array<NavigationGuard> = []

async function run(
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext,
  guardians: Array<NavigationGuard>
) {
  if (!_isInit) throw Error("GuardianRunner has not been initialized, call `init` first!")

  const allGuardians: Array<NavigationGuard> = [..._globalGuardians, ...guardians]

  for (const guardian of allGuardians) {
    const result = await guardian(to, from, next)

    if (result === true || result === undefined) continue
    if (result === false) return next(false)
    return next(result)
  }

  return next()
}

function init(globalGuardians: Array<NavigationGuard>): void {
  if (_isInit) throw Error("GuardianRunner has already been initialized!")

  _globalGuardians.push(...globalGuardians)
  _isInit = true
}

export default {
  init,
  run
}
